import { isAllQuarters } from './partnerScoreUtils';

export function sortByYearQuarter<T extends { year: number; quarter: number }>(
  data: T[],
  year: number,
  quarter: number,
): T[] {
  const filteredData = data.filter(
    item => item.year < year || (item.year === year && (isAllQuarters(quarter) || item.quarter <= quarter)),
  );

  return filteredData.sort((a, b) => {
    const yearDiff = (b?.year ?? 0) - (a?.year ?? 0);
    if (yearDiff !== 0) {
      return yearDiff;
    } else {
      return (b?.quarter ?? 0) - (a?.quarter ?? 0);
    }
  });
}
